import api from "@/requests";

export const fetchUserInfo = () => api.get("api/v1/Accounts/getUserInfo");

export const fetchRepaymentAccounts = () =>
  api.get("/api/v1/Accounts/GetRepaymentAccounts");
